<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="일감연계" tabActive="동고리 가입방법" bg="/images/sub/sub-visual6.webp">
                <template #tit>일감연계</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>동고리 가입방법</template>

            <ul class="signup-steps">
                <li v-for="(item, index) in items" :key="index">
                    <v-row>
                        <v-col cols="12">
                            <v-row no-gutters class="signup-steps__row">
                                <v-col cols="12" lg="auto">
                                    <v-card flat tile min-width="225" class="signup-steps__title">
                                        <v-chip color="primary" outlined>
                                            <txt-primary class="txt--lg font-weight-bold primary--text line-height-11">STEP {{ index + 1 }}</txt-primary>
                                        </v-chip>
                                        <u-tit-default class="tit--sm">
                                            {{ item.title }}
                                        </u-tit-default>
                                    </v-card>
                                </v-col>
                                <v-col>
                                    <v-card flat tile class="signup-steps__content">
                                        <v-row align="center" class="row--sm">
                                            <v-col v-if="item.steps" cols="12">
                                                <txt-primary class="txt--xl txt--dark">
                                                    <v-row align="center" class="ma-n4px ma-lg-n5px">
                                                        <template v-for="(step, index) in item.steps">
                                                            <v-col v-if="index != 0" :key="index" cols="auto" class="d-none d-lg-block pa-lg-5px">
                                                                <v-avatar color="primary" size="16" class="d-flex">
                                                                    <v-icon small color="white">mdi-chevron-right</v-icon>
                                                                </v-avatar>
                                                            </v-col>
                                                            <v-col :key="index" cols="12" lg="auto" class="pa-4px pa-lg-5px">
                                                                <v-row align="center" no-gutters>
                                                                    <v-col cols="auto">
                                                                        <v-sheet class="step-number">{{ index + 1 }}</v-sheet
                                                                        ><span class="d-none d-lg-inline-block">.&nbsp;</span>
                                                                    </v-col>
                                                                    <v-col>{{ step }}</v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </template>
                                                    </v-row>
                                                </txt-primary>
                                            </v-col>
                                            <v-col v-if="item.guide" cols="12">
                                                <u-tit-default class="tit--sm">
                                                    <div v-html="item.guide" />
                                                </u-tit-default>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-card color="grey-lighten-3" outlined tile :class="['image-wrap', { 'image-wrap--sm': item.image.small }]">
                                <div>
                                    <u-tit-default v-if="item.image.title" class="tit--sm text-center font-weight-regular mb-2 mb-md-4">
                                        {{ item.image.title }}
                                    </u-tit-default>

                                    <template v-if="item.image.children">
                                        <v-carousel hide-delimiters progress progress-color="primary" class="d-lg-none">
                                            <v-carousel-item v-for="(child, index) in item.image.children" :key="index" :src="child" alt="" eager />
                                        </v-carousel>
                                        <v-row class="d-none d-lg-flex">
                                            <v-col v-for="(child, index) in item.image.children" :key="index" cols="3">
                                                <img :src="child" alt="" class="d-block" />
                                            </v-col>
                                        </v-row>
                                    </template>
                                    <img v-else :src="item.image.src" alt="" />
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </li>
            </ul>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import CardPrimary from "@/components/publish/parents/cards/card-primary.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";

export default {
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        CardPrimary,
        TxtPrimary,
        UTitDefault,
    },
    data() {
        return {
            items: [
                {
                    title: "업장 정보 기입",
                    steps: ["네이버 회원가입", "설문조사 작성", "제출 후 협회 연락"],
                    guide: "네이버폼을 활용하여 자세한 업장 정보를 기입해주세요!",
                    image: {
                        src: "/images/donggori/step-1.webp",
                    },
                },
                {
                    title: "사진 정보 등록",
                    steps: ["각 협회별 국장님께 요청", "방문 촬영 진행", "패딧에 전달 후 홈페이지 등록"],
                    guide: "각 협회 국장님들께 요청하시면 방문하여 사진 촬영을 진행합니다.",
                    image: {
                        src: "/images/donggori/step-2.webp",
                    },
                },
                {
                    title: "채팅방 개설",
                    steps: ["오픈채팅방 개설", "봉제공장 이름 기입", "공장명_사장님 성함", "검색 허용 설정"],
                    image: {
                        title: "카카오톡 오픈 채널 개설 방안1",
                        children: ["/images/donggori/step-3-1.webp", "/images/donggori/step-3-2.webp", "/images/donggori/step-3-3.webp", "/images/donggori/step-3-4.webp"],
                    },
                },
                {
                    title: "링크 공유",
                    steps: ["기본 프로필 참여 허용", "링크 공유"],
                    image: {
                        title: "카카오톡 오픈 채널 개설 방안2",
                        children: ["/images/donggori/step-4-1.webp", "/images/donggori/step-4-2.webp", "/images/donggori/step-4-3.webp", "/images/donggori/step-4-4.webp"],
                    },
                },
                {
                    title: "채팅방 개설",
                    steps: ["오픈채팅방 개설", "봉제공장 이름 기입", "공장명_사장님 성함", "검색 허용 설정"],
                    image: {
                        src: "/images/donggori/step-5.webp",
                        small: true,
                    },
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.signup-steps {
    > li {
        &:not(:first-child) {
            padding-top: 60px;
            @media (min-width: 1024px) {
                padding-top: 80px;
            }
        }
    }
    &__row {
        gap: 4px;
    }
    &__title,
    &__content {
        padding: 16px;
        height: 100%;
        @media (min-width: 1024px) {
            padding: 40px;
        }
    }
    &__title {
        display: flex;
        gap: 10px;
        position: relative;
        justify-content: center;
        align-items: center;
        @media (min-width: 1024px) {
            flex-direction: column;
        }
        .v-chip {
            border-radius: 999px;
            @media (min-width: 1024px) {
                padding: 8px 16px !important;
                height: fit-content !important;
            }
        }
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--v-primary-base);
            opacity: 0.1;
            pointer-events: none;
        }
    }
    &__content {
        background-color: var(--v-grey-lighten5);
        display: flex;
        align-items: center;
    }
}
.step-number {
    border-radius: 50%;
    background: var(--v-primary-base);
    color: #fff;
    display: grid;
    place-items: center;
    aspect-ratio: 1;
    width: 20px;
    height: 20px;
    margin-right: 6px;
    font-size: 12px;
    font-weight: 700;
    @media (min-width: 1024px) {
        border-radius: initial;
        background: transparent;
        color: var(--v-grey-darken4);
        display: inline-block;
        place-items: initial;
        aspect-ratio: initial;
        width: fit-content;
        height: fit-content;
        margin-right: 0;
        font-size: inherit;
        font-weight: inherit;
    }
}
.image-wrap {
    padding: 16px;
    display: grid;
    place-items: center;
    @media (min-width: 1024px) {
        min-height: 618px;
    }
    &--sm {
        @media (min-width: 1024px) {
            padding: 80px 16px;
            min-height: initial;
        }
    }
    > img {
        display: block;
    }
    .v-carousel {
        ::v-deep {
            .v-window__prev,
            .v-window__next {
                margin: 0 8px;
                .v-btn {
                    background-color: var(--v-primary-base) !important;
                    opacity: 0.5;
                }
            }
        }
    }
}
</style>
